var React = require('react');

function DividerGreyWithLogo (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"stroke":"black","fill":"#282D3D","points":"0,364 0,196 183.491,196 282.296,0 -0.004,0 -0.004,560 98.801,364 ","key":0}),React.createElement("polygon",{"stroke":"white","fill":"#FFFFFF","points":"0,196 0,364 98.801,364 183.491,196 ","key":1})]);
}

DividerGreyWithLogo.defaultProps = {"overflow":"visible","focusable":"false","viewBox":"0 0 282.296 560"};

module.exports = DividerGreyWithLogo;

DividerGreyWithLogo.default = DividerGreyWithLogo;
